/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./review-result.vue?vue&type=template&id=500e5443&scoped=true&"
import script from "./review-result.vue?vue&type=script&lang=ts&"
export * from "./review-result.vue?vue&type=script&lang=ts&"
import style0 from "./review-result.vue?vue&type=style&index=0&id=500e5443&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500e5443",
  null
  
)

export default component.exports